<table mdbTable small="true" hover="true">
  <thead>
    <tr>
      <th [mdbTableSort]="contenedores" sortBy="contenedor">Contenedores <mdb-icon fas icon="sort"></mdb-icon></th>
      <th [mdbTableSort]="contenedores" sortBy="nobonus" class="text-right">No Bonificados <mdb-icon fas icon="sort"></mdb-icon></th>
      <th [mdbTableSort]="contenedores" sortBy="total" class="text-right">Total <mdb-icon fas icon="sort"></mdb-icon></th>
    </tr>
  </thead>
  <tbody>
    <tr mdbTableCol *ngFor="let c of contenedores; let i = index">
      <td>
        <a routerLink="/{{ uri }}-contenedor/{{ c.contenedor }}/{{ uri === 'productos' ? producto : usuario }}"
          [queryParams]="{inicio: inicio, fin: fin}">
          {{ c.nombre }}
        </a>
      </td>
      <td class="text-right">{{c.nobonus || '-'}}</td>
      <td class="text-right">{{c.total}}</td>
    </tr>
  </tbody>
</table>
<app-pagination [total]="total" (changePage)="onChangePage($event)"></app-pagination>